(function () {
  'use strict';

  angular
      .module('tfc.Terms')
      .controller('TermsCtrl', TermsCtrl);

  // @ngInject
  function TermsCtrl(Terms, Toast, Auth, $state, CookieJar, Nav) {
    var vm = this;
    vm.isTermsAccepted = false;

    function setTermsAccepted() {
      vm.user = Auth.getUser();
      if(vm.user) {
        Terms.getTermsOfUse(vm.user.uuid).then(function (responseSuccess) {
          if (responseSuccess.status === 200) {
            vm.isTermsAccepted = true;
          }
        });
      }
    }


    setTermsAccepted();

    vm.submit = function () {
      Terms.acceptTermsOfUse(vm.user.uuid).then(function () {
        Toast.success('Site.Feed.AcceptedTerms');
        CookieJar.set({name: 'tfc-retailer-terms', value: _.toString('accepted')});
        _.each($state.get(),function(state){
          if(state.data && state.data.requireTerms){
            state.data.requireTerms = false;
          }
        });
        $state.go(_.head(Nav.mainMenu()).state.name());
      });
    }
  }

})();
